<dgx-content-expander [hasShadow]="false">
  <!-- viewable area before dropdown -->
  <div header class="l_flex m-l_flex l_flex-grow">
    <div class="l_flex m-l_flex l_flex-grow l_flex-center-children __title">
      <div class="guts-m-h-1 m-no-guts center-item">
        <div class="icon-spot bg-color-sky-light color-sky-dark">
          <df-icon size="medium" icon="experience"></df-icon>
        </div>
      </div>
      <div class="guts-p-h-1 m-guts-p-l-half">
        <h3
          class="h3"
          [dgxLineClampText]="experience.title"
          [clampLinesMax]="1"
        ></h3>
        <div
          class="par par--small par--light"
          [dgxLineClampText]="getSubHeading()"
          [clampLinesMax]="1"
        ></div>
      </div>
    </div>
    <div
      class="l_flex m-l_flex l_flex-center-children guts-p-full-0 guts-m-l-auto"
    >
      <!-- no mobile skills count and action buttons will display in header before dropdown -->
      <div
        class="badge badge-pill badge-neutral guts-m-v-half guts-m-r-3 no-mobile"
      >
        {{ getPillSkillCount(experience.tags) }}
      </div>
      <div class="guts-m-v-half no-mobile">
        <button
          df-button
          class="color-blue guts-p-full-1"
          [dfButtonType]="'clear'"
          data-dgat="experience-5a3"
          (click)="editJob()"
        >
          {{ i18n.Core_Edit }}
        </button>
        <button
          df-button
          class="color-error guts-p-full-1"
          [dfButtonType]="'clear'"
          data-dgat="experience-d46"
          (click)="removeJob()"
        >
          {{ i18n.Core_Remove }}
        </button>
      </div>
    </div>
  </div>
  <!-- Body of content -->
  <div body class="guts-p-full-1 __description">
    <!-- mobile only skills coount and action buttons will display in dropdown-->
    <div
      class="l_flex m-l_flex l_flex-grow guts-p-full-0 guts-m-l-auto mobile-only"
    >
      <div
        class="guts-m-v-auto l_flex-center-children badge badge-pill badge-neutral"
      >
        {{ getPillSkillCount(experience.tags) }}
      </div>
      <div
        class="ls_flex-center-children guts-p-full-0 guts-m-l-auto guts-m-v-half"
      >
        <button
          df-button
          class="color-blue guts-p-full-1"
          [dfButtonType]="'clear'"
          data-dgat="experience-5a3"
          (click)="editJob()"
        >
          {{ i18n.Core_Edit }}
        </button>
        <button
          df-button
          class="color-error guts-p-full-1"
          [dfButtonType]="'clear'"
          data-dgat="experience-d46"
          (click)="removeJob()"
        >
          {{ i18n.Core_Remove }}
        </button>
      </div>
    </div>
    <div *ngIf="experience.description" class="par par--small par--light">
      {{ experience.description }}
    </div>
    <div class="guts-m-t-1">
      <ul class="inline-list">
        <li
          *ngFor="let tag of tags"
          class="guts-m-r-1 guts-m-b-1"
          data-dgat="experience-888"
        >
          <button
            df-button
            dfButtonType="primary"
            df-button-small
            class="bg-color-ebony-a08 color-ebony"
            (click)="removeSkill(tag)"
            data-dgat="assigned-skills-eab"
          >
            {{ tag.title | titlecase }}
            <df-icon
              size="small"
              icon="cross"
              class="guts-m-l-quart color-ebony-a61"
            ></df-icon>
          </button>
        </li>
      </ul>
    </div>
  </div>
</dgx-content-expander>
